module.exports = __webpack_public_path__ + "assets/img/36_1447.2c016dc4.jpg";